import React from "react";
import Marquee from "react-fast-marquee";

const brands = [
  "Carl ZEISS",
  "Heidelberg",
  "Manfrotto",
  "Tata Steel",
  "HP",
  "Logitech",
  "Konica Minolta",
  "Scala",
  "Ecu 360",
  "SAP",
  "Amazon",
  "McGraw Hill",
  "Luxor",
];

export default function TrustedBy({ showLink = true }) {
  return (
    <section
      data-testid="trusted-by"
      className="section-light pt-16 md:pt-24 pb-12 md:pb-16 overflow-hidden"
    >
      <div className="container-xl mb-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#86868B] mb-3">
              Trusted by
            </div>
            <h3 className="font-display text-[#1D1D1F] text-2xl md:text-3xl tracking-tight max-w-xl leading-snug">
              Global B2B sales &amp; marketing leaders — from Fortune 1000s to
              high-growth challengers.
            </h3>
          </div>
          {showLink && (
          <a
            href="/work"
            data-testid="trusted-by-see-work"
            className="text-[#1D1D1F] text-sm font-medium underline underline-offset-4 decoration-[#FFB000] decoration-2 hover:decoration-4 transition-all"
          >
            See client stories
          </a>
          )}
        </div>
      </div>

      <Marquee
        gradient
        gradientColor="#F5F5F7"
        gradientWidth={120}
        speed={42}
        pauseOnHover
        className="py-6"
      >
        {brands.concat(brands).map((b, i) => (
          <span
            key={i}
            data-testid={`brand-${i}`}
            className="font-display font-extrabold tracking-tight text-[#C7C7CC] text-4xl md:text-5xl lg:text-6xl mx-10 md:mx-16 select-none hover:text-[#1D1D1F] transition-colors"
            style={{ letterSpacing: "-0.03em" }}
          >
            {b}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
